angular.module('impactx.search').controller('TenderSearchListCtrl', [
    'SearchFilter',
    TenderSearchListController
]);

function TenderSearchListController(SearchFilter) {
    var self = this;
    self.nameSort = 0;
    SearchFilter.resetSort();

    self.sortByName = function () {
        self.nameSort = SearchFilter.sortByName(false);
        search();
    };

    function search() {
        self.containerCtrl.updateContent(1, SearchFilter.getSelectedSort(self.nameSort));
    }
}
